<div class="header">
  <h2 class="title" mat-dialog-title>Unsaved Changes</h2>
  <button class="close" mat-icon-button matTooltip="Close" (click)="goBack()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div class="message" mat-dialog-content>
  You have unsaved changes in this round. Would you like to save your draft before leaving?
</div>

<mat-dialog-actions class="actions">
  <button class="btn go-back" (click)="goBack()" cdkFocusInitial>Go Back</button>
  <button class="btn discard" (click)="discardChanges()">Discard Changes</button>
  <button class="btn blue-primary save-draft" (click)="saveDraft()">Save Draft</button>
</mat-dialog-actions>
